$(document).ready(function() {

  if (location.pathname === '/cart' || location.pathname === '/en/cart') {

    $('.cart__dynamic-checkout-buttons').hide(); 

    var today = new Date();
    var minDate = 0;
  
    $('.shipping-method-tybo').on('change', function() {
      $('.tybo-date-input').val('');

      loadNextDate()  

      if ($(this).val().length) {  
        $('.tybo-date-input').prop('disabled', false);
        $('.tybo-date-input').prop('readonly', true);
      } else {
        $('.tybo-date-input').prop('disabled', true);
        $('.tybo-date-input').prop('readonly', false);
      }

      var today = new Date();

      /*if (today.getDay() === 4) {  
        $('.cart__dynamic-checkout-buttons').hide(); 
        $('#tybo-shipping-date').prop('disabled', true);
        $('#tybo-shipping-date').prop('readonly', false); 
      } else if (today.getDay() === 5 && today.getHours() < 12) {   
        $('.cart__dynamic-checkout-buttons').hide(); 
        $('#tybo-shipping-date').prop('disabled', true);
        $('#tybo-shipping-date').prop('readonly', false);
      } else {*/ 
        // $('.cart__dynamic-checkout-buttons').show();  
        $('#tybo-shipping-date').prop('disabled', false);
        $('#tybo-shipping-date').prop('readonly', true); 
      // } 
      
      if ($(this).val() == 'Pickup') {             
        $('.pickup-time-tybo-cont').show();
        $('.shipping-terms').hide();
        $('.tybo-shipping-terms').hide(); 
      } else {
        $('.pickup-time-tybo-cont').hide(); 
        $('.shipping-terms').show();
      }
    });
  
    $('.custom-tybo-checkout').click(function() { 
      $('.tybo-qty-validation').hide(); 
      $('.tybo-shipping-validation').hide();
      $('.tybo-pickup-time-validation').hide();
      var shippingMethod = $('.shipping-method-tybo').val();
      var shippingDate = $('.tybo-date-input').val() ? $('.tybo-date-input').val() : false; 
      var pickupTime = $('.pickup-time-tybo').val(); 

      $.getJSON('/cart.js', function(cart) {
        if (!shippingMethod.length || !shippingDate.length) { 
          $('.tybo-shipping-validation').show();
        } else if ($('.shipping-method-tybo').val() == 'Shipping' && !$("#agree-shipping").is(":checked")) {
          $('.tybo-shipping-terms').show(); 
        } else {   
          var attributes = {};
    
          attributes['Shipping Method'] = shippingMethod;
    
          if (shippingMethod == 'Pickup') {
            attributes['Pickup Date'] = shippingDate;
            attributes['Pickup Time'] = pickupTime;
            attributes['Shipping Date'] = null;
          } else {
            attributes['Shipping Date'] = shippingDate;
            attributes['Pickup Date'] = null;
            attributes['Pickup Time'] = null;
          } 
          
          $.ajax({ 
            type: 'POST',
            url: '/cart/update.js',
            data: {
              'attributes': attributes 
            },
            dataType: 'json',
            success: function() {  
              $('.cart__checkout-button').click();
            } 
          });
        }
      }); 
    });
  }

  /*function getDaysUntilNextMonday() {
    const today = new Date();
    const dayOfWeek = today.getDay();
    let daysUntilMonday;
  
    if (dayOfWeek === 1) {
      daysUntilMonday = 7;
    } else if (dayOfWeek === 0) {
      daysUntilMonday = 1;
    } else {
      daysUntilMonday = 8 - dayOfWeek;
    }
  
    return daysUntilMonday;
  }*/

  function getDaysUntilNextMonday() {
    const today = new Date();
    const dayOfWeek = today.getDay();

    // If today is Sunday (0) or Monday (1), return days until the *following* Monday
    if (dayOfWeek === 0) return 8; // Sunday → next Monday is 8 days away
    if (dayOfWeek === 1) return 7; // Monday → next Monday is 7 days away

    // Otherwise, return days until the upcoming Monday
    return (8 - dayOfWeek);
  }

  function getDaysUntilNextTuesday() {
    const today = new Date();
    const dayOfWeek = today.getDay();

    // If today is Wednesday (3) or later, return days until the *following* Tuesday
    return (dayOfWeek >= 3) ? (9 - dayOfWeek) : (2 - dayOfWeek);
  }

  function getDaysUntilNextFriday() {
    const today = new Date();
    const dayOfWeek = today.getDay();
    let daysUntilFriday;
  
    if (dayOfWeek === 5) {
      daysUntilFriday = 7;
    } else {
      daysUntilFriday = (5 + 7 - dayOfWeek) % 7;
    }
  
    return daysUntilFriday === 0 ? 7 : daysUntilFriday;
  } 
  
  function loadNextDate() {
    var select = $('#tybo-shipping-date');
    select.empty(); 

    var today = new Date();
    var nextDate = new Date(today);
    
    if ($('.shipping-method-tybo').val() === 'Shipping') {
      const select = $('#tybo-shipping-date');
      const today = new Date();
      const currentDay = today.getDay(); // Sunday = 0, Monday = 1, ..., Saturday = 6
      const currentHour = today.getHours();
      const currentMinutes = today.getMinutes();

      select.append($('<option>', {
        value: '',
        text: 'Please select'
      }));

      // Check if it's past Wednesday 11:59 PM
      const deadlinePassed = (
        currentDay > 3 || // Thursday or later
        (currentDay === 3 && (currentHour > 23 || (currentHour === 23 && currentMinutes >= 59)))
      );

      // Calculate days until Monday of the target week
      const baseOffset = ((8 - currentDay) % 7); // days until next Monday
      const weeksAhead = deadlinePassed ? 2 : 1;
      const daysUntilTargetMonday = baseOffset + (7 * weeksAhead);

      for (let i = 0; i < 2; i++) {
        const futureDate = new Date(today);
        futureDate.setDate(today.getDate() + daysUntilTargetMonday + i); // Monday + i (0 or 1)

        const formattedDate = futureDate.toISOString().split('T')[0];
        const weekdayName = futureDate.toLocaleDateString('en-US', { weekday: 'long' });

        select.append($('<option>', {
          value: formattedDate,
          text: formattedDate
        }));
      }
    } else {
      const select = $('#tybo-shipping-date');
      const now = new Date();

      // Add default option
      select.append($('<option>', {
        value: '',
        text: 'Please select'
      }));

      for (let i = 0; i < 30; i++) {
        const futureDate = new Date(now);
        futureDate.setHours(futureDate.getHours() + 48 + (i * 24)); // 48h from now, then add 1 day per loop

        const formattedDate = futureDate.toISOString().split('T')[0];
        const weekdayName = futureDate.toLocaleDateString('en-US', { weekday: 'long' });

        select.append($('<option>', {
          value: formattedDate,
          text: formattedDate
        }));
      }
    }
  } 

  loadNextDate() 

  $('#tybo-shipping-date').change(function() {
    var selectedDate = $(this).val();
    var shippingMethod = $('.shipping-method-tybo').val();

    if (shippingMethod == 'Pickup') {
      if (selectedDate) {
        $('.pickup-time-tybo').prop('disabled', false);
      } else {
        $('.pickup-time-tybo').prop('disabled', true);
      }
    }
  }); 
});